import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { CancelamentoFalecimentoService } from '@/core/api/sicom-api/servicos/pessoa-fisica/cancelamento-falecimento/cancelamento-falecimento.service';
import { ServicoAnexoService } from '@/core/api/sicom-api/servicos/shared/servico-anexo.service';
import type { CancelamentoFalecimentoRequest, CancelamentoFalecimentoResponse } from '@/core/api/sicom-api/servicos/pessoa-fisica/cancelamento-falecimento/cancelamento-falecimento.model';

@Injectable({ providedIn: 'root' })
export class CancelamentoFalecimentoServicosService {
    constructor(
        private api: CancelamentoFalecimentoService,
        private servicoAnexo: ServicoAnexoService
    ) {}

    consultar(params: CancelamentoFalecimentoRequest, context?: HttpContext): Observable<CancelamentoFalecimentoResponse> {
        if (!params?.numeroProtocolo || !params?.anoProtocolo || !params?.ufCrm) {
            return throwError(() => new Error('Parâmetros inválidos: numeroProtocolo, anoProtocolo e ufCrm são obrigatórios.'));
        }

        return this.api.consultar(params, context);
    }

    efetivarSolicitacao(dto: CancelamentoFalecimentoResponse, context?: HttpContext): Observable<void> {
        if (!dto?.numeroProtocolo || !dto?.anoProtocolo || !dto?.ufCrmOrigem) {
            return throwError(() => new Error('Parâmetros inválidos: numeroProtocolo, anoProtocolo e ufCrmOrigem são obrigatórios para efetivar.'));
        }

        return this.api.efetivarSolicitacao(dto, context);
    }

    visualizarAnexo(idAnexo: string, context?: HttpContext): Observable<Blob> {
        const id = idAnexo?.trim();
        if (!id) {
            return throwError(() => new Error('Id do anexo não informado.'));
        }

        return this.servicoAnexo.visualizarAnexo(id, context);
    }
}
